import type { TreeItem } from './../components/tree/treeMapper'
import { StorageNodeTypeEnum } from '@d/sdk'

export enum SortOption {
  TypeAsc = 0,
  TypeDesc = 1,
  AlphaNumericAsc = 2,
  AlphaNumericDesc = 3,
  DateAsc = 4,
  DateDesc = 5,
}

export enum SortMode {
  Ascending,
  Descending,
}

export function recursiveSort(data: TreeItem[], compareFn: (a: TreeItem, b: TreeItem) => number): TreeItem[] {
  return data.map(item => ({
    ...item,
    children: item.children ? recursiveSort(item.children, compareFn) : undefined,
  })).sort(compareFn)
}

export function sortAlphanumeric(items: TreeItem[], sortMode: SortMode): TreeItem[] {
  if (sortMode === SortMode.Ascending)
    return recursiveSort(items, (a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }))

  else
    return recursiveSort(items, (a, b) => b.name.localeCompare(a.name, undefined, { numeric: true }))
}

export function sortByDate(items: TreeItem[], sortMode: SortMode): TreeItem[] {
  if (sortMode === SortMode.Ascending)
    return recursiveSort(items, (a, b) => a.lastModified.localeCompare(b.lastModified, undefined, { numeric: true }))
  else
    return recursiveSort(items, (a, b) => b.lastModified.localeCompare(a.lastModified, undefined, { numeric: true }))
}

export function sortByType(items: TreeItem[], sortMode: SortMode): TreeItem[] {
  if (sortMode === SortMode.Ascending) {
    return recursiveSort(items, (a, b) => {
      const aIsDir = a.type === StorageNodeTypeEnum.Directory
      const bIsDir = b.type === StorageNodeTypeEnum.Directory
      if (aIsDir && !bIsDir)
        return -1
      if (!aIsDir && bIsDir)
        return 1

      const aIsManual = a.type === StorageNodeTypeEnum.Manual
      const bIsManual = b.type === StorageNodeTypeEnum.Manual
      if (aIsManual && !bIsManual)
        return -1
      if (!aIsManual && bIsManual)
        return 1

      const aIsBin = a.type === StorageNodeTypeEnum.Bin
      const bIsBin = b.type === StorageNodeTypeEnum.Bin
      if (aIsBin && !bIsBin)
        return 1
      if (!aIsBin && bIsBin)
        return -1

      const aS = a?.mime ?? a.type
      const bS = b?.mime ?? b.type
      if (aS !== bS)
        return aS.localeCompare(bS)
      return a.name.localeCompare(b.name, undefined, { numeric: true })
    })
  }
  else {
    return recursiveSort(items, (a, b) => {
      const aIsDir = a.type === StorageNodeTypeEnum.Directory
      const bIsDir = b.type === StorageNodeTypeEnum.Directory

      if (aIsDir && !bIsDir)
        return 1
      if (!aIsDir && bIsDir)
        return -1

      const aIsManual = a.type === StorageNodeTypeEnum.Manual
      const bIsManual = b.type === StorageNodeTypeEnum.Manual
      if (aIsManual && !bIsManual)
        return 1
      if (!aIsManual && bIsManual)
        return -1

      const aIsBin = a.type === StorageNodeTypeEnum.Bin
      const bIsBin = b.type === StorageNodeTypeEnum.Bin
      if (aIsBin && !bIsBin)
        return -1
      if (!aIsBin && bIsBin)
        return 1

      const aS = a?.mime ?? a.type
      const bS = b?.mime ?? b.type

      if (aS !== bS)
        return bS.localeCompare(aS)
      return b.name.localeCompare(a.name, undefined, { numeric: true })
    })
  }
}
